<template>
    <div class="fill-height pa-2">
        <v-card class="fill-height d-flex flex-column of-y" style="max-height: 100%; position: relative; ">
            <v-progress-linear v-if="showLoading" absolute indeterminate></v-progress-linear>
            <v-card-title class="pa-0 ma-0 d-flex align-center">
                <div class="dlg-title-bar flex-grow-1">
                    {{ selectedSite.name }}
                </div>
            </v-card-title>

            <app-divider label="Site Info" show-expanded :expanded.sync="showSiteInfo"/>

            <v-scroll-y-transition hide-on-leave>
                <div v-if="showSiteInfo" class="pb-2">
                    <div class="d-flex align-center px-6 py-2">
                        <div class="flex-grow-1 flex-equal body-1">Account Status:</div>
                        <div class="flex-grow-1 flex-equal overline">{{ selectedSite.accountStatus || 'Active' }}</div>
                    </div>
                    <div class="d-flex align-center px-6 py-2">
                        <div class="flex-grow-1 flex-equal body-1">Billing Plan:</div>
                        <div class="flex-grow-1 flex-equal overline">{{ selectedSite.billingPlan || 'STARTER' }}</div>
                    </div>
                    <div class="d-flex align-center px-6 py-2">
                        <div class="flex-grow-1 flex-equal body-1">Contact Number:</div>
                        <div class="flex-grow-1 flex-equal body-1">{{ selectedSite.contactNumber || 'None Specified' }}</div>
                    </div>
                    <div class="d-flex align-center px-6 py-2">
                        <div class="flex-grow-1 flex-equal body-1">Trial Expiry:</div>
                        <div class="flex-grow-1 flex-equal body-1">{{ selectedSite.trialExpire ? format(new Date(selectedSite.trialExpire), dateFormats.longDateOnly) : 'None Specified' }}</div>
                    </div>
                    <div class="d-flex align-center px-6 py-2">
                        <div class="flex-grow-1 flex-equal body-1">Registered Name:</div>
                        <div class="flex-grow-1 flex-equal body-1">{{ selectedSite.companyName ? selectedSite.companyName : 'None Specified' }}</div>
                    </div>
                    <div class="d-flex align-center px-6 py-2">
                        <div class="flex-grow-1 flex-equal body-1">Vat No:</div>
                        <div class="flex-grow-1 flex-equal body-1">{{ selectedSite.vatNo ? selectedSite.vatNo : 'None Specified' }}</div>
                    </div>
                    <div class="d-flex align-start px-6 py-2">
                        <div class="flex-grow-1 flex-equal body-1">Billing Contacts:</div>
                        <div class="flex-grow-1 flex-equal body-1" v-if="selectedSite.billingContacts && selectedSite.billingContacts.length">
                            <div class="pb-1" v-for="contact in selectedSite.billingContacts">
                                {{ contact }}
                            </div>
                        </div>
                        <div v-else class="flex-grow-1 flex-equal body-1">
                            Not Specified
                        </div>
                    </div>
                    <div class="d-flex align-start px-6 py-2">
                        <div class="flex-grow-1 flex-equal body-1">Address:</div>
                        <div class="flex-grow-1 flex-equal body-1" v-if="selectedSite.address">
                            <div class="pb-1" v-if="selectedSite.address.line1">{{ selectedSite.address.line1 }}</div>
                            <div class="pb-1" v-if="selectedSite.address.line2">{{ selectedSite.address.line2 }}</div>
                            <div class="pb-1" v-if="selectedSite.address.city">{{ selectedSite.address.city }}</div>
                            <div class="pb-1" v-if="selectedSite.address.region">{{ selectedSite.address.region }}</div>
                            <div class="pb-1" v-if="selectedSite.address.areaCode">{{ selectedSite.address.areaCode }}</div>
                        </div>
                        <div v-else class="flex-grow-1 flex-equal body-1">
                            Not Specified
                        </div>
                    </div>
                </div>
            </v-scroll-y-transition>

            <app-divider v-if="user.masterAdmin" label="Partner Info" show-expanded :expanded.sync="showPartnerInfo"/>

            <v-scroll-y-transition hide-on-leave v-if="user.masterAdmin">
                <div v-if="showPartnerInfo && !resetPartnerInfo" class="pb-2">

                    <template v-if="selectedSite.partner">
                        <div class="d-flex align-center px-6 py-2">
                            <div class="flex-grow-1 flex-equal body-1">Partner:</div>
                            <div class="flex-grow-1 flex-equal body-1">{{ selectedSite.partner.name || 'Not Specified' }}</div>
                        </div>
                        <div class="d-flex align-center px-6 py-2">
                            <div class="flex-grow-1 flex-equal body-1">Contact Number:</div>
                            <div class="flex-grow-1 flex-equal body-1">{{ selectedSite.partner.contactNumber || 'Not Specified' }}</div>
                        </div>
                        <div class="d-flex align-center px-6 py-2">
                            <div class="flex-grow-1 flex-equal body-1">Contact Email:</div>
                            <div class="flex-grow-1 flex-equal body-1">{{ selectedSite.partner.email || 'Not Specified' }}</div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="body-2 grey--text overline text-center">
                            No Partner Linked To Site.
                        </div>
                    </template>

                    <div class="px-6 text-center py-2">
                        <v-btn small outlined color="primary" @click="showAssignPartner = true">{{selectedSite.partner ? 'Reassign' : 'Assign'}} Partner</v-btn>
                    </div>



                </div>
            </v-scroll-y-transition>
<!--Snapshots-->
            <app-divider label="Employee Snapshots" show-expanded :expanded.sync="showSnapshots"/>


<!--                <template v-slot:action>-->
<!--                    <v-tooltip top>-->
<!--                        <template v-slot:activator="{on}">-->
<!--                            <v-btn-->
<!--                                    dark-->
<!--                                    color="primary"-->
<!--                                    icon-->
<!--                                    v-on="on"-->
<!--                                    @click="showAddTeams = true"-->
<!--                            >-->
<!--                                <v-icon>mdi-plus</v-icon>-->
<!--                            </v-btn>-->
<!--                        </template>-->
<!--                        Add Teams-->
<!--                    </v-tooltip>-->
<!--                </template>-->
<!--            </app-divider>-->

            <v-scroll-y-transition hide-on-leave>
                <v-data-table
                        v-if="showSnapshots"
                        :headers="headers"
                        :items="selectedSite.snapshots"
                        :items-per-page="selectedSite.snapshots.length"
                        class="full-table"
                        hide-default-footer
                        fixed-header
                        item-key="_id"
                >
                    <template v-slot:item.runKey="{ item }">
                        <div class="d-flex align-center overline">
                            <v-icon small left>mdi-calendar</v-icon>
                            {{format(new Date(item.runKey + '-01'), 'MMMM')}}
                        </div>
                    </template>

                    <template v-slot:item.runTime="{ item }">{{format(new Date(item.runTime), dateFormats.longDate)}}</template>
                    <template v-slot:item.snapshot="{ item }">{{item.snapshot.length}}{{item.snapshot.length === 1 ? ' Employee' : ' Employees'}}</template>


                    <!--count-->


                    <template v-slot:item.more="{ item }">
                        <div class="d-flex align-center justify-end">
                            <v-tooltip left>
                                <template v-slot:activator="{on}">
                                    <v-btn
                                            color="primary"
                                            class="mx-2"
                                            small
                                            icon
                                            @click.stop="showSnapshot(item)"
                                            v-on="on"
                                    >
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                View Breakdown
                            </v-tooltip>
                        </div>

                    </template>

                </v-data-table>
            </v-scroll-y-transition>

<!--Assign Partner-->
            <app-dlg
                    v-if="showAssignPartner"
                    :show-dlg.sync="showAssignPartner"
                    title="Assign Partner Code To Site"
                    :default-padding="false"
            >

                <v-card-text class="mt-0 pt-0">
                    <v-text-field
                            ref="partnerCode"
                            v-model="partnerCode"
                            class="pb-2 flex-grow-1"
                            flat
                            prepend-icon="mdi-handshake"
                            label="Partner Code"
                            hide-details="auto"
                            color="primary"
                            dark
                            :rules="[validationRules.partnerCode]"
                            :error-messages="partnerErrors"
                    />
                </v-card-text>

                <template v-slot:actions>
                    <v-btn
                            class="ml-2"
                            small
                            color="primary"
                            @click="showAssignPartner = false"
                            outlined
                            size="small"
                            :disabled="assigningPartner"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                            @click="assignPartner"
                            small
                            class="ml-2"
                            color="secondary"
                            variant="contained"
                            size="small"
                            :disabled="assigningPartner || validationRules.partnerCode(partnerCode) !== true"
                            :loading="assigningPartner"
                    >
                        Assign Partner Code
                    </v-btn>
                </template>
            </app-dlg>


        </v-card>

        <app-employee-snapshot-explorer ref="snapshotExplorer"></app-employee-snapshot-explorer>
    </div>
</template>

<script>

import {User} from "@/models/user";
import AppList from "@/components/Shared/AppList/AppList";
import AppDlg from "@/components/Shared/AppDlg";
import {arrSplice, nameSort, validationRules, dateFormats} from "@/core/codeFunctions";
import AppEmployeeSnapshotExplorer from "@/components/Shared/EmployeeSnapshotExplorer/AppEmployeeSnapshotExplorer";
import {mapGetters} from "vuex";
import AppDivider from "@/components/Shared/AppDivider/AppDivider";
import {Device} from "@/models/device";
import {Team} from "@/models/team";
import AppUserSitePrefOptions from "@/components/Users/AppUserSitePrefOptions";
import {format} from "date-fns";

export default {
    components: {AppUserSitePrefOptions, AppDivider, AppDlg, AppList, AppEmployeeSnapshotExplorer},
    props: {
        selectedSite: Object
    },
    data() {
        return {
            showLoading: false,
            validationRules: validationRules,

            showSiteInfo: true,
            dateFormats,
            format,

            showPartnerInfo: true,
            showAssignPartner: false,
            partnerCode: null,
            partnerErrors: null,
            assigningPartner: false,
            resetPartnerInfo: false,

            showSnapshots: true,
            headers: [
                {text: 'Month', value: 'runKey'},
                {text: 'Created', value: 'runTime'},
                {text: 'Employees', value: 'snapshot'},
                {text: '', value: 'more', width: 64},
            ],
        }
    },
    watch: {
        showAssignPartner(val) {
            this.partnerCode = null;
            if (val)
                setTimeout(() => {
                    this.$refs.partnerCode.focus();
                })
        },
        partnerCode() {
            this.partnerErrors = null
        },
        resetPartnerInfo(val) {
            if (val)
                this.$nextTick(() => {this.resetPartnerInfo = false})
        }

    },
    methods: {
        showSnapshot(snapshot) {
            this.$refs.snapshotExplorer.previewSnapshot(snapshot)
        },
        async assignPartner() {
            this.partnerErrors = null;
            this.assigningPartner = true;
            try {
                const res = await this.$newReq('POST', `setup/partnerCode`, {partnerCode: this.partnerCode, siteId: this.selectedSite._id})
                if (!res.status)
                    return this.partnerErrors = ['Partner code not found']
                this.$emit('partnerUpdated', res.partnerInfo)
                this.showAssignPartner = false
                this.$snack.info('Changes Saved')
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
            } finally {
                this.assigningPartner = false
            }
        },
        //
        // async disableUser() {
        //     try {
        //         // Build The Update Object
        //         const updateKeys = ['disabledSiteIds'];
        //
        //         if (!this.editUser.disabledSiteIds.includes(this.$store.state.curSiteId)) {
        //             this.editUser.disabledSiteIds.push(this.$store.state.curSiteId)
        //         } else {
        //             arrSplice(this.editUser.disabledSiteIds, (id) => id === this.$store.state.curSiteId)
        //         }
        //
        //         this.disablingUser = true;
        //
        //         this.selectedUser.once('update', (payload) => {
        //             this.disablingUser = false;
        //             this.$emit('checkSelected')
        //         })
        //
        //         const res = await this.editUser.update(...updateKeys)
        //     } catch (e) {
        //         console.log(e)
        //         this.disablingUser = false;
        //     }
        // },
        //
        // async resetTotp() {
        //     try {
        //         this.resettingTotp = true;
        //         const res = await this.$newReq('POST', 'users/resetTotp', {_id: this.selectedUser._id})
        //         this.resettingTotp = false;
        //         this.$snack.info('TOTP reset')
        //     } catch (e) {
        //         console.log(e)
        //         this.resettingTotp = false;
        //     }
        // },
        //
        // async enableTOTP() {
        //     try {
        //         // Build The Update Object
        //         const updateKeys = ['totp'];
        //         this.editUser.totp.enabled = !this.editUser.totp.enabled
        //
        //         this.enablingTOTP = true;
        //         this.selectedUser.once('update', (payload) => {
        //             this.enablingTOTP = false;
        //         })
        //
        //         await this.editUser.update(...updateKeys)
        //     } catch (e) {
        //         console.log(e)
        //         this.enablingTOTP = false;
        //     }
        // },
        //
        // async saveChanges() {
        //     try {
        //
        //         if (!this.$refs.modifyForm.validate())
        //             return this.$snack.error('Please Complete All Fields')
        //
        //         // Check Username Duplicate
        //         const {duplicates} = await this.$newReq('POST', 'users/checkUsernameModify', {
        //             _id: this.editUser._id,
        //             username: this.editUser.username
        //         })
        //         if (duplicates)
        //             this.usernameErrors = 'Username Already Taken'
        //
        //         // Build The Update Object
        //         const updateKeys = ['name', 'username', 'totp', 'disabledSiteIds'];
        //         if (this.editUser.password)
        //             updateKeys.push("password")
        //
        //         this.showLoading = true;
        //         this.selectedUser.once('update', (payload) => {
        //             this.showLoading = false;
        //         })
        //
        //         await this.editUser.update(...updateKeys)
        //     } catch (e) {
        //         console.log(e)
        //         this.showLoading = false;
        //     }
        // },
        //
        // resetValue() {
        //     this.editUser = new User(JSON.parse(JSON.stringify(this.selectedUser)));
        //     if (this.$refs.modifyForm)
        //         this.$refs.modifyForm.resetValidation();
        //     this.editUserUsernameErrors = null
        //     this.showLoading = false;
        //     this.editUserChangesMade = false;
        //     this.resettingTotp = false;
        //     this.sendingPasswordReset = false;
        // },
        //
        // async sendPasswordReset() {
        //     try {
        //         this.sendingPasswordReset = true;
        //         const res = await this.$newReq('POST', 'users/passwordResetInvite', {_id: this.selectedUser._id})
        //         this.sendingPasswordReset = false;
        //         this.$snack.info('Password reset invite sent')
        //     } catch (e) {
        //         console.log(e)
        //         this.sendingPasswordReset = false;
        //     }
        // },
        //
        //
        // async addTeamsToUser() {
        //     try {
        //         const res = await this.$newReq('POST', `users/addTeams`, {
        //             userId: this.selectedUser._id,
        //             teamIds: this.addTeamIds
        //         })
        //         this.addTeamIds = [];
        //         this.showAddTeams = false;
        //     } catch (e) {
        //         this.$snack.netWorkError();
        //         this.addingTeams = false;
        //     } finally {
        //         this.addingTeams = false
        //     }
        // },

    },
    computed: {
        ...mapGetters(['user']),

    }

}
</script>

<style scoped>

</style>